import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'flagNameToKey',
    standalone: true
})
export class FlagNameToKeyPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) {
            return '';
        }

        return value.toLowerCase().replace(/\s+/g, '-');
    }
}
